<template>
  <div class="steps">
    <div class="steps_list">
      <div class="node" :class="{ 'active-node': pIndex == 0 }"></div>
      <div
        class="tail"
        :class="{ 'active-tail': pIndex == 0 }"
        :hidden="pIndex != 0"
      ></div>
      <div class="tail" :hidden="pIndex == 0"></div>
    </div>
    <div class="wrapper">
      <!-- <div class="date">
				{{item.date}}
			</div> -->
      <div class="content">
        <!-- <div class="content_l">
					<image :src="item.src" mode="aspectFill"></image>
				</div> -->
        <div class="content_r">
          <div class="name" :class="{ 'active-name': pIndex == 0 }">
            <span>{{ item.notice }}</span>
          </div>
          <div class="scan_time">
            {{ item.create_time }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
	item：没条记录详情
	activity: 当前进度条状态
	wrapperStatus：流程状态对应字段
	wrapperTitle：详情对应字段
	index：进度条排列序号 index == 0代表最后一个没有竖立进度条
	date：时间
	 */
export default {
  name: 'm-steps',
  props: {
    item: {
      type: Object,
    },
    pIndex: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.steps {
  display: flex;
  .steps_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
  }
  .date {
    padding-bottom: 10px;
    color: #aaaaaa;
    text-align: left;
  }
  .wrapper {
    width: 100%;
  }
  .tail {
    width: 2px;
    height: calc(100% - 15px);
    background-color: #eee;
  }
  .active-tail {
    width: 2px;
    background-color: #31a775 !important;
  }
  .active-node {
    background-color: #31a775 !important;
  }
  .node {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #aaa;
  }
  .content {
    display: flex;
    width: 95%;
    padding: 0 0 20px 0;
    border-radius: 5px;
    background-color: #fff;
  }
  .content_l {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    image {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }
  }
  .content_r {
    width: 70%;
    .name {
      color: gray;
    }
    .active-name {
      color: black;
    }
    .scan_time {
      margin: 6px 0 0;
      color: #aaa;
    }
  }
}
</style>
